import React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import ResignationForm from './ResignationForm';

const EmployeeResignation = ({ open, toggle, employeeId }) => {
  const DialogWrapper = styled(Dialog)(
    () => `
          .MuiDialog-container {
              height: 100vh;
          }
          
          .MuiDialog-paperScrollPaper {
              max-height: calc(100vh - 80px)
          }
      `
  );

  return (
    <DialogWrapper
      open={open}
      keepMounted
      maxWidth="sm"
      fullWidth
      scroll="paper"
      onClose={toggle}
    >
      <ResignationForm toggle={toggle} employeeId={employeeId} />
    </DialogWrapper>
  );
};

export default EmployeeResignation;
